import { ProgressBeacon } from '@kaltura-corp/unisphere-plg-types';
import { apiEndpoints, avatarStudioPackageIds, Packages, StorageKeys } from './constants';

export const sendFunnelAnalytics = (beacon: ProgressBeacon, packageId: string | null = null, useSendBeacon = false) => {
  console.log('Funnel analytics invoked with data:', {
    beacon,
    packageId,
  });

  let sessionPackageId = packageId || '';
  if (!sessionPackageId) {
    // If packageId is not provided as an argument, attempt to retrieve it from sessionStorage
    console.log('packageId was not provided, attempting to retrieve from sessionStorage');
    try {
      sessionPackageId = JSON.parse(sessionStorage.getItem(StorageKeys.PACKAGE_ID) || '');
    } catch (e) {
      console.error('Error parsing packageId from sessionStorage:', e);
      return;
    }
  }

  if (avatarStudioPackageIds.includes(sessionPackageId as Packages)) {
    console.log('Sending funnel analytics beacon:', beacon);
    sendAnalyticsBeacon(beacon, useSendBeacon).then().catch(error => console.error(error));
  } else {
    console.log(`sessionPackageId does not belong to avatar funnel flow, skipping funnel analytics beacon`);
  }
}

export const sendAnalyticsBeacon = async (
  beacon: ProgressBeacon,
  useSendBeacon = false
): Promise<any> => {
  const payload = JSON.stringify({
    eventType: beacon.type,
    eventPage: beacon.page || undefined,
    eventObject: beacon.event,
    properties: beacon.properties,
  });

  if (useSendBeacon) {
    try {
      // wrap JSON payload in a Blob to preserve application/json content-type
      const jsonPayload = new Blob([payload], { type: 'application/json' });
      const success = navigator.sendBeacon(apiEndpoints.funnelAnalyticsEvent, jsonPayload);
      if (!success) {
        throw new Error('Failed to queue analytics beacon');
      }
      return { success: true };
    } catch (error) {
      console.error('Error sending analytics with sendBeacon:', error);
      throw error;
    }
  } else {
    try {
      const request = new Request(
        apiEndpoints.funnelAnalyticsEvent,
        {
          method: 'POST',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Credentials': 'true',
          },
          body: payload,
        }
      );
      const response = await fetch(request);
      if (!response.ok) {
        throw new Error(`Failed to send analytics: ${response.statusText}`);
      }
      return response;
    } catch (error) {
      console.error('Error sending analytics:', error);
      throw error;
    }
  }
};
